<div class="modal-header">
    <p class="modal-title text-center"><strong>Milestones - {{visaname}} - {{candidatename}}</strong></p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>


<div>
    <div class="container-fluid">


        <div class="milestone" *ngIf="mileStone.length > 0; else noContent">

            <div class="title">
                <div class="row">
                    <div class="col-md-4">
                        <h6>Total process timeline : {{mileStone[0].milestoneTimeline | workingday }} </h6>
                    </div>
                    <div class="col-md-8 text-right">
                        <ul class="legends">
                            <li class="completed">
                                <div class="iconTimeLine">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24.434" height="41.868"
                                        viewBox="0 0 24.434 41.868">
                                        <path id="Path_1" data-name="Path 1"
                                            d="M-604.564,62.78v-.593q0-18.437,0-36.875c0-.159,0-.318,0-.477a1.273,1.273,0,0,1,1.967-1.114c1.133.634,2.25,1.3,3.371,1.953q7.1,4.147,14.208,8.3a1.709,1.709,0,0,1,.892.953,1.4,1.4,0,0,1-.782,1.693q-2.989,1.75-5.982,3.492-5.367,3.13-10.737,6.254a.575.575,0,0,0-.335.577q.014,7.7.007,15.4c0,.128.011.255.019.444.894,0,1.77-.009,2.647,0a1.168,1.168,0,0,1,1.159.807,1.285,1.285,0,0,1-1.255,1.789c-1.576.013-3.152,0-4.729,0-1,0-2,0-2.993,0a1.251,1.251,0,0,1-1.387-1.315,1.217,1.217,0,0,1,1.359-1.288C-606.294,62.773-605.458,62.78-604.564,62.78Zm16.722-27.453L-601.821,27.1V43.557Z"
                                            transform="translate(608.488 -23.522)" fill="#57e188" />
                                    </svg>
                                </div>
                                Completed
                            </li>
                            <li class="In-Progress"><span></span>
                                <div class="iconTimeLine">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24.434" height="41.868"
                                        viewBox="0 0 24.434 41.868">
                                        <path id="Path_1" data-name="Path 1"
                                            d="M-604.564,62.78v-.593q0-18.437,0-36.875c0-.159,0-.318,0-.477a1.273,1.273,0,0,1,1.967-1.114c1.133.634,2.25,1.3,3.371,1.953q7.1,4.147,14.208,8.3a1.709,1.709,0,0,1,.892.953,1.4,1.4,0,0,1-.782,1.693q-2.989,1.75-5.982,3.492-5.367,3.13-10.737,6.254a.575.575,0,0,0-.335.577q.014,7.7.007,15.4c0,.128.011.255.019.444.894,0,1.77-.009,2.647,0a1.168,1.168,0,0,1,1.159.807,1.285,1.285,0,0,1-1.255,1.789c-1.576.013-3.152,0-4.729,0-1,0-2,0-2.993,0a1.251,1.251,0,0,1-1.387-1.315,1.217,1.217,0,0,1,1.359-1.288C-606.294,62.773-605.458,62.78-604.564,62.78Zm16.722-27.453L-601.821,27.1V43.557Z"
                                            transform="translate(608.488 -23.522)" fill="#ffe600" />
                                    </svg>
                                </div> In-Progress
                            </li>
                            <li class="Not-Applicable"><span></span>
                                <div class="iconTimeLine">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24.434" height="41.868"
                                        viewBox="0 0 24.434 41.868">
                                        <path id="Path_1" data-name="Path 1"
                                            d="M-604.564,62.78v-.593q0-18.437,0-36.875c0-.159,0-.318,0-.477a1.273,1.273,0,0,1,1.967-1.114c1.133.634,2.25,1.3,3.371,1.953q7.1,4.147,14.208,8.3a1.709,1.709,0,0,1,.892.953,1.4,1.4,0,0,1-.782,1.693q-2.989,1.75-5.982,3.492-5.367,3.13-10.737,6.254a.575.575,0,0,0-.335.577q.014,7.7.007,15.4c0,.128.011.255.019.444.894,0,1.77-.009,2.647,0a1.168,1.168,0,0,1,1.159.807,1.285,1.285,0,0,1-1.255,1.789c-1.576.013-3.152,0-4.729,0-1,0-2,0-2.993,0a1.251,1.251,0,0,1-1.387-1.315,1.217,1.217,0,0,1,1.359-1.288C-606.294,62.773-605.458,62.78-604.564,62.78Zm16.722-27.453L-601.821,27.1V43.557Z"
                                            transform="translate(608.488 -23.522)" fill="#188CE5" />
                                    </svg>
                                </div> Not Applicable
                            </li>
                            <li class="Not-Started"><span></span>
                                <div class="iconTimeLine">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24.434" height="41.868"
                                        viewBox="0 0 24.434 41.868">
                                        <path id="Path_1" data-name="Path 1"
                                            d="M-604.564,62.78v-.593q0-18.437,0-36.875c0-.159,0-.318,0-.477a1.273,1.273,0,0,1,1.967-1.114c1.133.634,2.25,1.3,3.371,1.953q7.1,4.147,14.208,8.3a1.709,1.709,0,0,1,.892.953,1.4,1.4,0,0,1-.782,1.693q-2.989,1.75-5.982,3.492-5.367,3.13-10.737,6.254a.575.575,0,0,0-.335.577q.014,7.7.007,15.4c0,.128.011.255.019.444.894,0,1.77-.009,2.647,0a1.168,1.168,0,0,1,1.159.807,1.285,1.285,0,0,1-1.255,1.789c-1.576.013-3.152,0-4.729,0-1,0-2,0-2.993,0a1.251,1.251,0,0,1-1.387-1.315,1.217,1.217,0,0,1,1.359-1.288C-606.294,62.773-605.458,62.78-604.564,62.78Zm16.722-27.453L-601.821,27.1V43.557Z"
                                            transform="translate(608.488 -23.522)" fill="#747480" />
                                    </svg>
                                </div> Not Started
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container-fluid" *ngIf="mileStone.length > 1;">
                <div class="row">
                    <div class="col">
                        <div class="process">
                            <div class="line"></div>
                            <ul *ngIf="mileStone.length > 0 ">
                                <li *ngFor="let item of mileStone | slice:1">
                                    <h6> {{item.milestoneName}} </h6>
                                    <div [ngClass]="legendStyle(item.activityStatusId)">
                                        <div class="iconTimeLine">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24.434" height="41.868"
                                                viewBox="0 0 24.434 41.868">
                                                <path id="Path_1" data-name="Path 1"
                                                    d="M-604.564,62.78v-.593q0-18.437,0-36.875c0-.159,0-.318,0-.477a1.273,1.273,0,0,1,1.967-1.114c1.133.634,2.25,1.3,3.371,1.953q7.1,4.147,14.208,8.3a1.709,1.709,0,0,1,.892.953,1.4,1.4,0,0,1-.782,1.693q-2.989,1.75-5.982,3.492-5.367,3.13-10.737,6.254a.575.575,0,0,0-.335.577q.014,7.7.007,15.4c0,.128.011.255.019.444.894,0,1.77-.009,2.647,0a1.168,1.168,0,0,1,1.159.807,1.285,1.285,0,0,1-1.255,1.789c-1.576.013-3.152,0-4.729,0-1,0-2,0-2.993,0a1.251,1.251,0,0,1-1.387-1.315,1.217,1.217,0,0,1,1.359-1.288C-606.294,62.773-605.458,62.78-604.564,62.78Zm16.722-27.453L-601.821,27.1V43.557Z"
                                                    transform="translate(608.488 -23.522)" fill="#57e188" />
                                            </svg>
                                        </div>
                                        <div class="row">
                                            <div class="col-md">
                                                <p>Timeline : <strong>{{(item.milestoneTimeline) | workingday
                                                        }}</strong> </p>
                                            </div>
                                            <div class="col-md">
                                                <p> EDD Date :<strong>{{item.exceptedProcessDate|
                                                        date:'dd-MMM-yy'}}</strong> </p>
                                            </div>
                                            <div class="col-md">
                                                <p>Completion Date :<strong>{{item.compeletedDate |
                                                        date:'dd-MMM-yy'}}</strong></p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <ng-template #noContent>

            <div class="milestone">No milestone details available !</div>
        </ng-template>

    </div>
</div>